import { useState } from "react";
import axiosInstance from "../../CommonMethhods/axiosInstance";
import { ApiResDecrypt } from "../../CommonMethhods/CommonMethods";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";

export const useDownloadAll = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadAllStatementReport = async (payload) => {
    setIsDownloading(true);
    
    try {
      const response = await axiosInstance.post(
        Dashboard_Client_Report.DOWNLOAD_STATEMENT_REPORT_URL,
        payload,
      );
      const decryptedResponse = ApiResDecrypt(response.data);
      if (decryptedResponse.status === 0) {
        return { success: true, data: decryptedResponse };
      } else if (decryptedResponse.status === 1) {
        return { success: false, data: decryptedResponse };
      }
      return { success: false };
    } catch (error) {
      console.error("Error downloading all statement reports:", error);
      return { success: false };
    } finally {
      setIsDownloading(false);
    }
  };

  return { isDownloading, downloadAllStatementReport };
};
